import type { Vec3 } from '../geo/types';
import type { CollisionWorld } from '../nav/types';
import type { Townsperson } from './types';

export function nearbyTownsperson(
  people: readonly Townsperson[],
  visitor: Vec3,
  forward: Vec3,
  collision: CollisionWorld
): Townsperson | null {
  let closest: Townsperson | null = null;
  let distance = 4.5;
  for (const person of people) {
    const dx = person.position[0] - visitor[0];
    const dz = person.position[2] - visitor[2];
    const gap = Math.hypot(dx, dz);
    if (gap >= distance || gap < 0.1 || (dx * forward[0] + dz * forward[2]) / gap < 0.25) continue;
    if (Math.abs(person.position[1] + 1.7 - visitor[1]) > 2) continue;
    const end = collision.move([visitor[0], -visitor[2]], [dx, -dz]);
    if (Math.hypot(end[0] - person.position[0], end[1] + person.position[2]) > 0.15) continue;
    closest = person;
    distance = gap;
  }
  return closest;
}
